$(document).ready(function() {
    // General
    const appHeight = () => {
        const doc = document.documentElement;
        doc.style.setProperty('--app-height', `${window.innerHeight}px`);
    }
    window.addEventListener('resize', appHeight)
    appHeight()

    desktopHeader();
    mobileHeader();
    woocommerceFunctions();
    scrollToTop();
    initAccordions();
    toggleLanguageSelector();

    // Newsletter Signup
    newsletterSignup();

    // Newsletter Popup
    newsletterPopup();
    
    // Product/Category Grid filter
    productGridFilter();

    // Archive page filter
    archivePageFilter();

    // Filterable Column Module
    filterableColumns();
    
    // Slider/Carousels
    slickArrowNavigation();
    initHeroSlider();
    initProductCatSlider();
    initTextImgSlider();
    initProductGallerySlider();
});